import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '@incentivegames/ig-component-common/lib/index';

import RestrictedContainer from 'components/RestrictedContainer';

const Error = () => {
  const { t } = useTranslation();
  return (
    <RestrictedContainer>
      <ErrorMessage wrapperBackgroundColor="white" wrapperMargin="5px" messagePadding="10px" messageTextAlign="center" errorTextColor="black" error={t('error-message')} />
    </RestrictedContainer>
  );
};

export default Error;
